import React from "react";
import { ParallaxArtWrapper } from "../three/ParallaxArtWrapper";

export function CarlsPage() {
    return <ParallaxArtWrapper/>;
}
